import { DevicesGetRequestParams } from "@lib/core";

export interface DeviceDefaultParams  extends DevicesGetRequestParams { }
export interface DeviceDefaultParamsLimited extends DevicesGetRequestParams { }
export class DeviceDefaultParams {
  constructor() {
    this.select = "*,\
      provider:providers(*),\
      version:versions(*),\
      device_status:device_statuses(*)";
    this.order = "id.asc";
  }
}
export class DeviceDefaultParamsLimited {
  constructor() {
    this.select = "id,provider_id,serial_number,sensor,primary_pcb,pin,active,last_battery_level,last_communicated_at,created_at,updated_at,version_id,device_status_id,last_timestamp,last_device_connected,last_tamper,last_record_mode,last_sensor_voltage,assigned_user_id,\
      provider:providers(*),\
      version:versions(*),\
      device_status:device_statuses(*)";
    this.order = "id.asc";
  }
}